import { GeTokenData } from '@/types';

export const fixSafariReferer = (bodyRequest: string): string => {
    const body: GeTokenData = JSON.parse(bodyRequest);
    const { successUrl, failureUrl } = body.order;
    const { href, pathname } = location;
    if (!failureUrl.includes(pathname)) {
      const [_, succes] = successUrl.split('?');
      body.order.failureUrl = href;
      body.order.successUrl = `${href}?${succes}`;
    }

    return JSON.stringify(body);
};
